import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

async function logoutUser(): Promise<any> {
    try {
        return (await axiosInstance.post("/Auth/Logout")).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useLogout() {
    return useMutation<any, Error>(() => logoutUser());
}
